<script>
    import { Navigate, navigateTo } from 'svelte-router-spa';
    import { alumnos } from "../../MainStore.js";
    import { AlumnoDTO } from "../../api/DTOS/Alumno.dto.js";

    export let currentRoute;

    const currentPath = currentRoute.name.replace("/index", "");

    let alumnoDTO = new AlumnoDTO();

    const clickAgregar = async () => {
        await alumnos.agregar(alumnoDTO);
        navigateTo(`/alumnos/`);
    };
</script>

<div class="card">
    <div class="card-header">
        Agregar alumno
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label htmlFor="nombres" class="bmd-label-floating">Nombres</label>
                    <input type="text" id="nombres" class="form-control" bind:value={alumnoDTO.nombres}/>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label htmlFor="apellidos" class="bmd-label-floating">Apellidos</label>
                    <input type="text" id="apellidos" class="form-control" bind:value={alumnoDTO.apellidos}/>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label htmlFor="dni" class="bmd-label-floating">DNI</label>
                    <input type="number" id="dni" class="form-control" bind:value={alumnoDTO.dni}/>
                </div>
            </div>
            <div class="col-6">
                <div class="row align-items-center">
                    <div class="col-6">
                        <div class="form-group">
                            <label htmlFor="cohorte" class="bmd-label-floating">Cohorte</label>
                            <input type="number" id="cohorte" class="form-control" bind:value={alumnoDTO.cohorte}/>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label htmlFor="lf" class="bmd-label-floating">L/F</label>
                            <input type="text" id="lf" class="form-control" bind:value={alumnoDTO.lf}/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-end">
            <div class="col-4 text-right">
                <Navigate to="/alumnos">
                    <button class="btn btn-raised mr-2 btn-secondary">Volver</button>
                </Navigate>
                <button class="btn btn-raised btn-success" on:click={clickAgregar}>Agregar</button>
            </div>
        </div>
    </div>
</div>